import { ROOT_CONSTANT } from "../../../constants";

const { 
  icon_update_status, 
  icon_modal_billing,
  icon_mark_as_disbursed, 
  icon_mark_as_cancel_payroll,
  icon_revert_for_processing_payroll,
  icon_warning,
  icon_modal_company_active,
  icon_modal_company_suspended,
  icon_modal_company_terminated,
} = ROOT_CONSTANT.IMG.ICON.MODAL;
const { icon_bank_rhb } = ROOT_CONSTANT.IMG.ICON.BANK;

export const MODAL_ACTION = {
  confirmation_mark_as_active_employee: "confirmation_mark_as_active_employee",
  confirmation_mark_as_active_employer: "confirmation_mark_as_active_employer",
  confirmation_mark_as_active_company: "confirmation_mark_as_active_company",
  confirmation_mark_as_suspended_employee: "confirmation_mark_as_suspended_employee",
  confirmation_mark_as_suspended_employer: "confirmation_mark_as_suspended_employer",
  confirmation_mark_as_suspended_company: "confirmation_mark_as_suspended_company",
  confirmation_mark_as_terminated_employee: "confirmation_mark_as_terminated_employee",
  confirmation_mark_as_terminated_employer: "confirmation_mark_as_terminated_employer",
  confirmation_mark_as_terminated_company: "confirmation_mark_as_terminated_company",
  confirmation_bulk_publish_billing_list: "confirmation_bulk_publish_billing_list",
  confirmation_publish_billing_billing_list: "confirmation_publish_billing_billing_list",
  confirmation_verify_payment_billing_list: "confirmation_verify_payment_billing_list",
    generate_rhb_payment: "generate_rhb_payment",
  confirmation_mark_as_cancelled_payroll: "confirmation_mark_as_cancelled_payroll",
  confirmation_mark_as_disbursed_payroll: "confirmation_mark_as_disbursed_payroll",
  confirmation_bulk_mark_as_disbursed_payroll: "confirmation_bulk_mark_as_disbursed_payroll",
  confirmation_revert_for_processing_payroll: "confirmation_revert_for_processing_payroll",
  confirmation_bulk_revert_for_processing_payroll: "confirmation_bulk_revert_for_processing_payroll",
  account_suspend: "account_suspend",
}


export const MODALS = {
  [MODAL_ACTION.confirmation_mark_as_active_employee]: {
    img: icon_update_status,
    title: "Mark as active",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employee as active.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_active_employer]: {
    img: icon_update_status,
    title: "Mark as active",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employer as active.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_active_company]: {
    img: icon_modal_company_active,
    title: "Mark as active",
    content: ({ coid, name }) => [
      `You are about to mark this company as active.`,
      `${coid}/ ${name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_suspended_employee]: {
    img: icon_update_status,
    title: "Mark as suspended",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employee as temporarily suspended.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_suspended_employer]: {
    img: icon_update_status,
    title: "Mark as suspended",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employer as temporarily suspended.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_suspended_company]: {
    img: icon_modal_company_suspended,
    title: "Mark as suspended",
    content: ({ coid, name }) => [
      `You are about to mark this company as temporarily suspended.`,
      `${coid}/ ${name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_terminated_employee]: {
    img: icon_update_status,
    title: "Mark as terminated",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employee as permanently terminated.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_terminated_employer]: {
    img: icon_update_status,
    title: "Mark as terminated",
    content: ({ name, memid, company_name }) => [
      `You are about to mark this employer as permanently terminated.`,
      `${name} (${memid})/ ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_terminated_company]: {
    img: icon_modal_company_terminated,
    title: "Mark as terminated",
    content: ({ coid, name }) => [
      `You are about to mark this company as permanently terminated.`,
      `${coid}/ ${name}`,
    ],
  },
  [MODAL_ACTION.confirmation_bulk_publish_billing_list]: {
    img: icon_modal_billing,
    title: "Bulk Publish",
  },
  [MODAL_ACTION.confirmation_publish_billing_billing_list]: {
    img: icon_modal_billing,
    title: "Publish Billing",
    content: ({ billid, amount, company_name, coid }) => [
      `You are about to publish this billing to customer.`,
      `${billid}/ RM${amount} / ${company_name} (${coid})`,
    ],
  },
  [MODAL_ACTION.confirmation_verify_payment_billing_list]: {
    img: icon_modal_billing,
    title: "Verify Payment",
    content: ({ billid, amount, company_name, coid }) => [
      `You are about to verify this billing as paid.`,
      `${billid}/ RM${amount} / ${company_name} (${coid})`,
    ],
  },
  [MODAL_ACTION.generate_rhb_payment]: {
    img: icon_bank_rhb,
    title: "Generate RHB payment file",
  },
  [MODAL_ACTION.confirmation_mark_as_cancelled_payroll]: {
    img: icon_mark_as_cancel_payroll,
    title: "Mark as cancelled",
    content: ({ prid, employee_name, employee_memid, company_name, coid }) => [
      `You are about to mark this payroll advance request as cancelled`,
      `${prid}/ ${employee_name} (${employee_memid})/ ${company_name} (${coid})`,
    ],
  },
  [MODAL_ACTION.confirmation_mark_as_disbursed_payroll]: {
    img: icon_mark_as_disbursed,
    title: "Mark as disbursed",
    content: () => [
      `You are about to mark payroll advance requests as disbursed.`,
    ],
  },
  [MODAL_ACTION.confirmation_bulk_mark_as_disbursed_payroll]: {
    img: icon_mark_as_disbursed,
    title: "Bulk mark as disbursed",
  },
  [MODAL_ACTION.confirmation_revert_for_processing_payroll]: {
    img: icon_revert_for_processing_payroll,
    title: "Revert for processing",
    content: ({ prid, employee_name, company_name }) => [
      `You are about to revert this payroll advance request as ready for processing.`,
      `${prid}/ ${employee_name} / ${company_name}`,
    ],
  },
  [MODAL_ACTION.confirmation_bulk_revert_for_processing_payroll]: {
    img: icon_revert_for_processing_payroll,
    title: "Bulk revert for processing",
  },
  [MODAL_ACTION.account_suspend]: {
    img: icon_warning,
    title: "Account suspend",
  },
}

export const MODALS_ASSIGN = [
  MODAL_ACTION.generate_rhb_payment,
  MODAL_ACTION.confirmation_bulk_mark_as_disbursed_payroll,
  MODAL_ACTION.confirmation_revert_for_processing_payroll,
  MODAL_ACTION.confirmation_bulk_revert_for_processing_payroll,
  MODAL_ACTION.confirmation_bulk_publish_billing_list,
]

export const MODALS_STANDARD = [
  MODAL_ACTION.confirmation_mark_as_active_employee,
  MODAL_ACTION.confirmation_mark_as_active_employer,
  MODAL_ACTION.confirmation_mark_as_active_company,
  MODAL_ACTION.confirmation_mark_as_suspended_employee,
  MODAL_ACTION.confirmation_mark_as_suspended_employer,
  MODAL_ACTION.confirmation_mark_as_suspended_company,
  MODAL_ACTION.confirmation_mark_as_terminated_employee,
  MODAL_ACTION.confirmation_mark_as_terminated_employer,
  MODAL_ACTION.confirmation_mark_as_terminated_company,
  MODAL_ACTION.confirmation_publish_billing_billing_list,
  MODAL_ACTION.confirmation_verify_payment_billing_list,
  MODAL_ACTION.confirmation_mark_as_cancelled_payroll,
  MODAL_ACTION.confirmation_mark_as_disbursed_payroll,
]
